import { RouteObject } from 'react-router-dom';

import CommandsIndex from '@webclient/components/pages/commands';

import importOrReload from '@webclient/lib/importOrReload';
import protectRoutes from '@webclient/lib/protectRoutes';

import ErrorPage from '@webclient/pages/error';
import HomePage from '@webclient/pages/home';
import { FullScreenOutlet, MainOutlet } from '@webclient/pages/IndexPage';
import paths from '@webclient/router/paths';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <FullScreenOutlet />,
    errorElement: <ErrorPage />,
    loader: protectRoutes,
    children: [
      {
        path: paths.editCommand.pathname,
        lazy: async () => {
          const { default: CommandDesignerPage } = await importOrReload(
            () => import('@webclient/pages/command-designer'),
          );

          return {
            Component: CommandDesignerPage,
          };
        },
      },
    ],
  },
  {
    path: '/',
    element: <MainOutlet />,
    errorElement: <ErrorPage />,
    loader: protectRoutes,
    children: [
      {
        index: true,
        hydrateFallbackElement: <HomePage />,
        lazy: async () => {
          const { default: HomePage } = await importOrReload(
            () => import('@webclient/pages/home'),
          );
          return {
            Component: HomePage,
          };
        },
      },
      {
        path: paths.search.pathname,
        lazy: async () => {
          const { default: SearchPage } = await importOrReload(
            () => import('@webclient/pages/search'),
          );
          return {
            Component: SearchPage,
          };
        },
      },
      {
        path: paths.live.pathname,
        lazy: async () => {
          const { default: LivePage } = await importOrReload(
            () => import('@webclient/pages/live'),
          );
          return {
            Component: LivePage,
          };
        },
      },
      {
        path: paths.liveSession.pathname,
        lazy: async () => {
          const { default: LiveSessionPage } = await importOrReload(
            () => import('@webclient/pages/live-session'),
          );
          return {
            Component: LiveSessionPage,
          };
        },
      },
      {
        path: paths.connectors.pathname,
        lazy: async () => {
          const { default: ConnectorsPage } = await importOrReload(
            () => import('@webclient/pages/connectors'),
          );
          return {
            Component: ConnectorsPage,
          };
        },
      },
      {
        path: paths.commands.pathname,
        lazy: async () => {
          const { default: Commands } = await importOrReload(
            () => import('@webclient/components/pages/commands/Commands'),
          );
          return {
            element: (
              <CommandsIndex>
                <Commands />
              </CommandsIndex>
            ),
          };
        },
      },
      {
        path: paths.commandDetails.pathname,
        lazy: async () => {
          const { default: CommandDetails } = await importOrReload(
            () => import('@webclient/components/pages/commands/CommandDetails'),
          );
          return {
            element: (
              <CommandsIndex>
                <CommandDetails />
              </CommandsIndex>
            ),
          };
        },
      },
      {
        path: paths.commandDetailsEditor.pathname,
        lazy: async () => {
          const { default: CommandDetailsEditor } = await importOrReload(
            () =>
              import(
                '@webclient/components/pages/commands/CommandDetailsEditor'
              ),
          );
          return {
            element: (
              <CommandsIndex>
                <CommandDetailsEditor />
              </CommandsIndex>
            ),
          };
        },
      },
      {
        path: paths.auditThread.pathname,
        lazy: async () => {
          const { default: AuditPage } = await importOrReload(
            () => import('@webclient/pages/audit'),
          );
          return {
            Component: AuditPage,
          };
        },
      },
      {
        path: paths.history.pathname,
        lazy: async () => {
          const { default: HistoryPage } = await importOrReload(
            () => import('@webclient/pages/history'),
          );
          return {
            Component: HistoryPage,
          };
        },
      },
      {
        path: paths.sso.pathname,
        lazy: async () => {
          const { default: SsoPage } = await importOrReload(
            () => import('@webclient/pages/sso'),
          );
          return {
            Component: SsoPage,
          };
        },
      },
      {
        path: paths.editSso.pathname,
        lazy: async () => {
          const { default: SsoEditorPage } = await importOrReload(
            () => import('@webclient/pages/sso-editor'),
          );
          return {
            Component: SsoEditorPage,
          };
        },
      },
      {
        path: paths.users.pathname,
        lazy: async () => {
          const { default: UsersPage } = await importOrReload(
            () => import('@webclient/pages/users'),
          );
          return {
            Component: UsersPage,
            errorElement: <ErrorPage />,
          };
        },
      },
      {
        path: paths.getTheApp.pathname,
        lazy: async () => {
          const { default: GetTheAppPage } = await importOrReload(
            () => import('@webclient/pages/get-the-app'),
          );
          return {
            Component: GetTheAppPage,
          };
        },
      },
      {
        path: paths.knowledgeBase.pathname,
        lazy: async () => {
          const { default: KnowledgeBasePage } = await importOrReload(
            () => import('@webclient/pages/knowledge-base'),
          );
          return {
            Component: KnowledgeBasePage,
          };
        },
      },
      {
        path: paths.upgradeAccount.pathname,
        lazy: async () => {
          const { default: UpgradeAccountPage } = await importOrReload(
            () => import('@webclient/pages/upgrade-account'),
          );
          return {
            Component: UpgradeAccountPage,
          };
        },
      },
      {
        path: paths.bots.pathname,
        lazy: async () => {
          const { default: BotsPage } = await importOrReload(
            () => import('@webclient/pages/bots'),
          );
          return {
            Component: BotsPage,
          };
        },
      },
      {
        path: paths.botConfig.pathname,
        lazy: async () => {
          const { default: BotConfigPage } = await importOrReload(
            () => import('@webclient/pages/bot-config'),
          );
          return {
            Component: BotConfigPage,
          };
        },
      },
    ],
  },
];

export default routes;
